<app-header></app-header>
<div class="body">
    <router-outlet></router-outlet>
</div>
<mat-toolbar class="position" color="primary">
    <mat-toolbar-row class="justify-content-between">
        <span>Copyright © {{year}}<a href="https://www.parasprint.in/"> ParasPrint</a></span>
    </mat-toolbar-row>
</mat-toolbar>